// extracted by mini-css-extract-plugin
module.exports = {"main":"Avatar_main__17QwE","activeDot":"Avatar_activeDot__1yn9-","active":"Avatar_active__1oC95","loader":"Avatar_loader__36U_g","loading":"Avatar_loading__2Vx7B"};